import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd'
import { BOLETA_DE_VENTA, FACTURA } from '../../../../common/types/tipoComprobanteType';

const InputGroup = Input.Group;
const { Option } = Select;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-9"}>
                <Form.Item>
                    <InputGroup compact>
           {/*              <Form.Item style={{ width: '20%' }}>
                            {
                                props.onGetFieldDecorator('flagExportacion', {
                                    initialValue: props.formValues.flagExportacion,
                                    valuePropName: 'checked'
                                })(<Checkbox>Exportación</Checkbox>)
                            }
                        </Form.Item> */}
                        {
                          props.onGetFieldValue('idTipoComprobante') !== undefined &&  (props.onGetFieldValue('idTipoComprobante')).key === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagDetraccion', {
                                        initialValue: props.formValues.flagDetraccion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagDetraccion", e.target.checked)}
                                        >
                                            Detracción
                                    </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                           {props.onGetFieldValue('flagDetraccion') ?
                        <Form.Item style={{ width: '40%' }}>
                            {props.onGetFieldDecorator('idDetraccion', {
                                initialValue: props.formValues.idDetraccion ?
                                    { key: props.formValues.idDetraccion } : undefined,
                                rules: [{
                                    required: true,
                                    message: 'Campo obligatorio.',
                                }]
                            })(
                                <Select showSearch labelInValue
                                    placeholder={"Seleccione Detracción"}
                                    optionFilterProp="children"
                                    onChange={(item, element) => props.onChangeTotals("idDetraccion", element.props.data.porcentaje)}
                                >
                                    {props.formValues.detracciones.map(item => (
                                        <Option
                                            key={item.id}
                                            value={item.id}
                                            data={item}
                                        >{item.codigoSunat + " - " + item.nombre}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item> : null
                }
                    </InputGroup>
                </Form.Item>
            </div>
       
            <div className="col-md-3 pt-10">
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5" >
                            <div className="total-inline">
                                <label>Porcentaje Percepción</label>
                                <div>{props.onGetFieldValue('porcentajePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Porcentaje Detracción</label>
                                <div>{props.onGetFieldValue('porcentajeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.onGetFieldValue('sumaTotalDetalle').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.onGetFieldValue('sumaIgv').toFixed(2) === "-0.00" ? "0.00" : props.onGetFieldValue('sumaIgv').toFixed(2)}</div>
                    </div>
                </div>
{/*                 <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>ISC</label>
                        <div>{props.onGetFieldValue('sumaIsc').toFixed(2)}</div>
                    </div>
                </div> */}
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Persección</label>
                                <div>{props.onGetFieldValue('importePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Percepción</label>
                                <div>{props.onGetFieldValue('totalPercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Detracción</label>
                                <div>{props.onGetFieldValue('importeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Detracción</label>
                                <div>{props.onGetFieldValue('totalDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
            </div>
        </div>
    );
}